export default "__VITE_PUBLIC_ASSET__98f746a1__"